import React from 'react';
import Axios from 'axios';
import { withRouter } from 'react-router-dom';
import { Navbar, Nav, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom'
import '../scss/custom.scss';
import './Navbar.css';
import { ROOT_URL } from '../actions';
import {OverlayTrigger, Tooltip } from 'react-bootstrap';

class NavigationMember extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           // year : this.props.year,
        };
    }

    logoutUser() {
        localStorage.clear();
    }
    componentDidMount(){
        let memberId = sessionStorage.getItem('imark-memberId');
        Axios.get(ROOT_URL + '/fbi-vendors?memberId=' + (memberId))
            .then(resp => this.setState({ conversionTab: resp.data }));
        
    }
    render() {
        if(this.state.conversionTab == "No FBI Vendors for this member"){
        return (
            <header>
                <Navbar className="mb-3 shadow-sm bd-navbar">
                    <Navbar.Brand>
                    {/* <h3 style= {{marginLeft: '50px',"font-family": 'Fantsy', color: 'rgb(255, 127, 14)' , 'font-size':' xx-large' ,'font-variant': 'proportional-nums','text-decoration': 'underline','textDecorationStyle': "double"}} >Rebate.ai</h3> */}
                                              <Link to="/"  className="btn btn-link"  > <img  height="35" src={process.env.PUBLIC_URL + '/IMARK Logo.png'} alt="img  " />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Text>{this.props.groupId}</Navbar.Text>
                    <Nav className="navbar-nav mr-auto">
                        <NavLink to="/Member/MemberData" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">Member Overview</NavLink>
                        <NavLink to="/Member/VerifiedData" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">IMARK Verified</NavLink>
                        <NavLink to="/Member/InvoiceData" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">Invoices</NavLink>
                        <NavLink to="/Member/PurchasedOrders" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">Purchase Orders</NavLink>
                        <NavLink to="/Member/Conversionopp" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">Conversion Opportunity</NavLink>
                        <NavLink to="/Member/FBIRebate"  style={{cursor:"not-allowed"}} onClick={e => e.preventDefault()} className="nav-link">FBI Rebate</NavLink>
                        <div className="navOptions">
                            <form className="form-inline">
                                <div className="navbar-form navbar-right">
                                <OverlayTrigger overlay={(<Tooltip id="callModal"> Contact Us</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                
                                    <a href="mailto:imarkplumbing.helpdesk@tredence.com, imark@tredence.com" className="btn btn-link"  data-placement="bottom" data-container="body" ><i className="fas fa-envelope"></i></a>
                                    </OverlayTrigger>
                                    <OverlayTrigger overlay={(<Tooltip id="callModal"> Logout</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                
                                        <Link to="/logout" onClick={(e) => { this.logoutUser() }} className="btn btn-link"  ><i className="fas fa-power-off"></i></Link>
                                       </OverlayTrigger>


                                </div>
                            </form>
                        </div>
                    </Nav>

                
                </Navbar>
            </header>

        );
        }
        else{
            return (
                <header>
                    <Navbar className="mb-3 shadow-sm bd-navbar">
                        <Navbar.Brand>
                            <Link to="/"  className="btn btn-link"  > <img  height="35" src={process.env.PUBLIC_URL + '/IMARK Logo.png'} alt="img  " /></Link>
                            {/* <h3 style= {{marginLeft: '50px',"font-family": 'Fantsy', color: 'rgb(255, 127, 14)' , 'font-size':' xx-large' ,'font-variant': 'proportional-nums','text-decoration': 'underline','textDecorationStyle': "double"}} >Rebate.ai</h3> */}
                                              </Navbar.Brand>
                        <Navbar.Text>{this.props.groupId}</Navbar.Text>
                        <Nav className="navbar-nav mr-auto">
                            <NavLink to="/Member/MemberData" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">Member Overview</NavLink>
                            <NavLink to="/Member/VerifiedData" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">IMARK Verified</NavLink>
                            <NavLink to="/Member/InvoiceData" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">Invoices</NavLink>
                            <NavLink to="/Member/PurchasedOrders" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">Purchase Orders</NavLink>
                            <NavLink to="/Member/Conversionopp" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">Conversion Opportunity</NavLink>
                            <NavLink to="/Member/FBIRebate" className="nav-link" activeStyle={{
    textDecorationLine: 'underline',
    textDecorationColor:"#2d75c3",
    textDecorationStyle:"double",
  }} activeClassName="active">FBI Rebate</NavLink>
                            <div className="navOptions">
                                <form className="form-inline">
                                    <div className="navbar-form navbar-right">
                                    <OverlayTrigger overlay={(<Tooltip id="callModal"> Contact Us</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                
                                    <a href="mailto:imarkplumbing.helpdesk@tredence.com, imark@tredence.com" className="btn btn-link"  data-placement="bottom" data-container="body" ><i className="fas fa-envelope"></i></a>
                                    </OverlayTrigger>
                                    <OverlayTrigger overlay={(<Tooltip id="callModal"> Logout</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="down">
                
                                    <Link to="/logout" onClick={(e) => { this.logoutUser() }} className="btn btn-link" ><i className="fas fa-power-off"></i></Link>
    </OverlayTrigger>
    
                                    </div>
                                </form>
                            </div>
                        </Nav>
    
                    
                    </Navbar>
                </header>
    
            );

        }
    }
}
export default withRouter(NavigationMember);